<template>
  <div class="addQuantity">
    <el-dialog title="新增定额" :visible.sync="addQuantityVisible" width="90%" :show-close="true">
      <div class="content flex h-100 bg-f3f4f7">
        <div id="moveLeftQ" class="h-100 flex-column bg-ff menu" style="width: 200px">
          <div class="left-top">
            <div class="flex-1 font-16-30313a">定额分类</div>
          </div>
          <div class="flex-1 h-0" v-if="deptList && deptList.length">
            <cate-menu :menu-data="deptList" :special-item="1" @on-choose="onChooseMenu" :choose-id="chooseDeptId" :not-operate="true"></cate-menu>
          </div>
        </div>
        <move-horizon moveId="moveLeftQ"></move-horizon>
        <div class="flex-1 flex-column w-0 ptb-10 pr-20">
          <div class="flex mb-10">
            <div class="title flex align-center bg-ff flex-1">
              <div class="decoration-line mr-5"></div>
              <div class="font-16-f5971d font-bold">{{currentClassify.name}}</div>
            </div>
            <div class="flex ml-10">
              <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
                <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
                <el-input type="text" placeholder="输入关键字" v-model="keywords" clearable @keyup.enter.native="searchBtn(1)"></el-input>
              </div>
              <button class="btn-30-bg-82b925" @click="searchBtn(1)">搜索</button>
            </div>
          </div>
          <div class="flex-1 flex-column h-0">
            <div class="mb-10 flex-1 h-0 flex">
              <erp-table ref="erpTableQuota" @change-current-row="changeCurrentRow" :table-data="tableData" :loading="loading" :column-data="columnData" :customs="[{field: 'subcontractPrice', visible: permission.includes('checkComputation')}]" @on-dbl-click="OnAddQuota"  @on-addQuota="OnAddQuota"></erp-table>
            </div>
            <pagination :page-size="pages" :page-no="page" v-model="page" :page-total="limit" :total="total" @on-jump="jump"></pagination>
            <move-vertical :max="560" :min="100" class="mtb-15" moveDom="bottom" moveId="moveTopQ"></move-vertical>
            <div id="moveTopQ" class="pt-15 flex-column" style="height: 200px">
              <div class="flex align-center">
                <div class="flex align-center mr-20 cursor pb-5 relative" :class="{'tabActive': index === smallTabIndex}" v-for="(item, index) in smallTab" :key="index" @click="switchSmallTab(index)">
                  <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
                  <div class="font-bold" :class="index === smallTabIndex ? 'font-16-f5971d' : 'font-16-30313a'">{{item}}</div>
                </div>
              </div>
              <div class="hr mb-20" style="margin-top: -1px;"></div>
              <div class="overflow-y flex-1">
                <div class="text-left font-12-30313a" v-if="smallTabIndex == 0">
                  <div>{{list.workmanship}}</div>
                </div>
                <div class="text-left flex" v-if="smallTabIndex == 1">
                  <div v-for="(item, index) in photoList" :key="index" class="mr-10 p-relative flex-column mb-10">
                    <el-image style="width: 90px; height: 90px" :src="item.completePath" :preview-src-list="srcList" fit="cover"></el-image>
                    <div class="font-12-30313a text-center">{{item.name}}</div>
                  </div>
                </div>
                <div class="text-left flex" v-if="smallTabIndex == 2">
                  <div class="flex-column align-start w-100" @click="addQuotaSmall">
                    <div class="btn-24-bg-ff flex align-center mb-10 button">
                      <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
                      添加定额
                    </div>
                    <div style="height: 150px">
                      <erp-table class="grayTable" ref="erpTable2" @change-current-row="changeCurrentRow" :table-data="tableData2" :loading="loading" :column-data="columnData2"></erp-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <AddMaterialy ref="addMaterialy" title="添加定额用量"></AddMaterialy>
  </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
import CateMenu from '../../../components/CateMenu'
import MoveHorizon from '../../../components/MoveHorizon'
import MoveVertical from '../../../components/MoveVertical'
import Pagination from '@/components/Pagination'
import AddMaterialy from './AddMaterialy.vue'
export default {
  name: 'AddQuantity',
  components: {CateMenu, ErpTable, MoveHorizon, MoveVertical, Pagination, AddMaterialy},
  props: ['budgetContentId', 'budgetId', 'budgetRoomId', 'budgetContentList', 'define', 'replaceId', 'isGive'],
  data () {
    return {
      page: 1,
      limit: 20,
      pages: 0,
      total: 0,
      addQuantityVisible: false,
      chooseDeptId: 0,
      isClassifyShow: true,
      currentClassify: {},
      deptList: [],
      list: {},
      photoList: [],
      srcList: [],
      keywords: null,
      smallTab: ['工艺说明', '相关图片', '定额用量'],
      smallTabIndex: 0,
      loading: false,
      tableData: [],
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        }, {
          field: 'operate',
          title: '操作',
          width: '120',
          fixed: 'left',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-bg-85 btn-hover',
            title: '新增',
            methodName: 'on-addQuota'
          }]
        }, {
          field: 'specialItem',
          title: '特项',
          width: '150'
        }, {
          field: 'code',
          title: '定额编码',
          width: '200'
        }, {
          field: 'name',
          title: '定额项目',
          minWidth: '400'
        }, {
          field: 'unit',
          title: '单位',
          width: '100'
        }, {
          field: 'customerPrice',
          title: '客户价',
          width: '150'
        }, {
          field: 'subcontractPrice',
          title: '分包价',
          width: '150'
        }
      ],
      tableData2: [],
      columnData2: [{
        field: 'type',
        title: '人材机',
        width: '120',
        formatter: 'toQuotaType',
        editType: 'select',
        editRender: {
          name: 'select',
          options: [
            {
              value: 1,
              label: '人工'
            },
            {
              value: 2,
              label: '辅料'
            },
            {
              value: 3,
              label: '机械'
            },
            {
              value: 4,
              label: '其他'
            }
          ]
        }
      }, {
        field: 'specialItem',
        title: '特项',
        width: '55'
      }, {
        field: 'name',
        title: '材料名称',
        width: '100'
      }, {
        field: 'unit',
        title: '单位',
        width: '200'
      }, {
        field: 'quantity',
        title: '数量',
        width: '200'
      }, {
        field: 'costPrice',
        title: '客户单价',
        width: '200'
      }, {
        field: 'customerPrice',
        title: '客户合价',
        minWidth: '100'
      }],
      permission: []
    }
  },
  created () {
    this.getPermission()
  },
  mounted () {
    this.getAllDept()
  },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'budget',
        parentGroup: 'budget'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    addQuotaSmall () {
      this.$refs.addMaterialy.addMaterialyVisible = true
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseDeptId) {
        this.chooseDeptId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.keywords = ''
        this.isClassifyShow = true
        this.budgetQuantities()
      }
    },
    changeCurrentRow (row) {
      this.list = row
      this.photoList = this.list.quotaPhotoList
      for (var i = 0; i < this.photoList.length; i++) {
        this.srcList.push(this.photoList[i].completePath)
      }
      this.getBudgetContentId()
    },
    getAllDept () {
      this.deptList = []
      this.axios.post(`quotaClassify/findAllClassify`, {companyId: this.$store.state.companyId}).then(res => {
        this.deptList = res.data.data
      })
    },
    budgetQuantities (isRefresh) {
      let params = {
        page: this.page,
        limit: this.limit,
        keywords: this.keywords,
        status: 1,
        companyId: this.$store.state.companyId
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseDeptId
      }
      this.axios.post('quota/queryForPage', params).then(res => {
        if (res.data.success) {
          this.loading = false
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.pages = res.data.data.pages
        }
      })
    },
    jump (page) { // 分页
      this.page = page
      this.budgetQuantities()
    },
    getBudgetContentId () {
      let params = {
        budgetContentId: this.budgetContentId
      }
      this.axios.post('budgetQuantities/list', params).then(res => {
        if (res.data.success) {
          this.tableData2 = res.data.data
        }
      })
    },
    OnAddQuota (row) {
      this.$emit('set-quota', row)
      // this.addQuantityVisible = false
    },
    searchBtn (a) {
      this.page = 1
      this.isClassifyShow = false
      this.getAllDept()
      this.budgetQuantities()
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.budgetQuantities()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .addQuantity /deep/ .el-dialog{
    height: 80%;
    display: flex;
    flex-direction: column;
  }
  .addQuantity /deep/ .el-dialog__body{
    flex: 1;
    min-height: 0;
    height: 0;
  }
  .button{
    border: solid 1px #e2e2e2;
    border-radius: 4px;
    cursor: pointer;
  }
  .menu{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
  }
  .hide-x{
    box-shadow: none!important;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    font-weight: bold;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content .title{
    height: 30px;
    padding-left: 10px;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/enterRoomItem/AddQuantity.vue